<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="dataLoaded">Add Sold Notice</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="spinner" *ngIf="!dataLoaded"></div>
    <ng-container *ngIf="dataLoaded" [formGroup]="form">
        <div class="row">
            <div class="col-sm-2 mvd_form-group">
                <h2>Sale Date</h2>
                <p-calendar id="dateOfSale" [showIcon]="true" formControlName="dateOfSale"></p-calendar>
                <control-validation-messages control="dateOfSale"></control-validation-messages>
            </div>
        </div>

        <h2>Buyer's Name</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label for="buyersName">First and Last or Organization</label>
                    <input class="mvd_form-control" formControlName="buyersName" id="buyersName" [readonly]="form.value.isBuyerUnknown || createSoldNoticeRefundResult" maxlength="256" />
                    <control-validation-messages control="buyersName"></control-validation-messages>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Unknown Buyer</label>
                    <input formControlName="isBuyerUnknown" type="checkbox" [readonly]="createSoldNoticeRefundResult" (change)="unknownBuyerClicked()" />
                    <control-validation-messages control="isBuyerUnknown"></control-validation-messages>
                </div>
            </div>
        </fieldset>

        <h2>Buyer's Address</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label for="addressLine1">Street Address</label>
                    <input class="mvd_form-control" formControlName="addressLine1" id="addressLine1" [readonly]="form.value.isAddressUnknown || createSoldNoticeRefundResult" maxlength="40" />
                    <control-validation-messages control="addressLine1"></control-validation-messages>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label for="addressLine2">Apt, Ste, Etc.</label>
                    <input class="mvd_form-control" formControlName="addressLine2" id="addressLine2" [readonly]="form.value.isAddressUnknown || createSoldNoticeRefundResult" maxlength="40" />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Unknown Address</label>
                    <input formControlName="isAddressUnknown" [readonly]="createSoldNoticeRefundResult" type="checkbox" (change)="unknownAddressClicked()" />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label for="city">City</label>
                    <input class="mvd_form-control" formControlName="city" id="city" [readonly]="form.value.isAddressUnknown || createSoldNoticeRefundResult" maxlength="26" />
                    <control-validation-messages control="city"></control-validation-messages>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label for="jurisdictionId">State</label>
                    <select *ngIf="!form.value.isAddressUnknown" class="mvd_form-control" formControlName="jurisdictionId" id="jurisdictionId">
                        <option [ngValue]="null">- Select -</option>
                        <option *ngFor="let jurisdiction of jurisdictions" value="{{jurisdiction.id}}">{{jurisdiction.code}}</option>
                    </select>
                    <input class="mvd_form-control" *ngIf="form.value.isAddressUnknown" readonly="readonly" />
                    <control-validation-messages control="jurisdictionId"></control-validation-messages>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label for="postalZipCode">ZIP Code</label>
                    <input class="mvd_form-control" formControlName="postalZipCode" id="postalZipCode" [readonly]="form.value.isAddressUnknown || createSoldNoticeRefundResult" maxlength="9" />
                    <control-validation-messages control="postalZipCode"></control-validation-messages>
                </div>
            </div>
        </fieldset>
</ng-container>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button *ngIf="!createSoldNoticeRefundResult" type="button" class="btn--default" (click)="cancel()">Cancel</button>
        <button *ngIf="createSoldNoticeRefundResult" type="button" class="btn--default" (click)="cancel()">Close</button>
        <button *ngIf="!createSoldNoticeRefundResult" class="btn--primary" type="submit" (click)="saveSoldNotice()">Save</button>
        <button *ngIf="createSoldNoticeRefundResult" class="btn--primary" type="submit" (click)="startRegistrationCredit()">Start Registration Credit ${{createSoldNoticeRefundResult.refundTotal}}</button>
    </div>
</div>

